"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var colorBg = _a.colorBg,
      colorText = _a.colorText,
      colorPrimary = _a.colorPrimary,
      colorTextSecondary = _a.colorTextSecondary;
  return {
    base: {
      fill: colorText.normal,
      display: 'inline-block',
      animation: 'spin 1s cubic-bezier(0.49, 0.28, 0.49, 0.67) infinite'
    },
    '@keyframes spin': {
      to: {
        transform: 'rotate(360deg) translatez(0)'
      }
    },
    primary: {
      fill: colorPrimary.normal
    },
    secondary: {
      fill: colorTextSecondary.normal
    },
    accent: {
      fill: colorBg.normal
    },
    dangerouslyStopAnimation: {
      animation: 'none'
    }
  };
};